// pages/ResetPasswordPage.js

import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axios from '../services/axios';

const Container = styled.div`
  max-width: 400px;
  margin: 4rem auto;
  padding: 2rem;
  border-radius: 12px;
  background: ${({ theme }) => theme.cardBackground || '#fefefe'};
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  font-family: ${({ theme }) => theme.fontFamily || 'inherit'};
`;

const Title = styled.h2`
  margin-bottom: 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.primaryColor || '#007bff'};
`;

const Input = styled.input`
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-family: ${({ theme }) => theme.fontFamily || 'inherit'};
`;

const Button = styled.button`
  width: 100%;
  padding: 0.75rem;
  border: none;
  background-color: ${({ theme }) => theme.primaryColor || '#007bff'};
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.primaryHover || '#0056b3'};
  }
`;

const Message = styled.p`
  margin-top: 1rem;
  color: ${({ error }) => (error ? 'red' : 'green')};
  font-weight: 500;
`;

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const uid = params.get('uid');
  const token = params.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (password !== confirm) {
      setMessage('Passwords do not match.');
      setError(true);
      return;
    }

    try {
      await axios.post('/api/password-reset/confirm/', {
        uid,
        token,
        new_password: password,
      });
      setError(false);
      setMessage('Password reset. Redirecting...');
      setTimeout(() => navigate('/login'), 2000);
    } catch {
      setMessage('Invalid or expired reset link.');
      setError(true);
    }
  };

  return (
    <Container>
      <Title>Set New Password</Title>
      <form onSubmit={handleSubmit}>
        <Input
          type="password"
          placeholder="New password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Input
          type="password"
          placeholder="Confirm password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
        <Button type="submit">Reset Password</Button>
      </form>
      {message && <Message error={error}>{message}</Message>}
    </Container>
  );
};

export default ResetPasswordPage;
